import { Modal, Button } from 'react-bootstrap';
import icon_elysia_brain from '../../assets/icon-elysia-brain.svg';
import { useNavigate } from 'react-router-dom';
import useElysiaStore from '@/app/elysia-store';

interface BlockModalProps {
  show: boolean;
  hide: () => void;
  type: string;
}

const BlockModal = ({ show, hide, type }: BlockModalProps) => {
  const navigate = useNavigate();
  const setChatAgent = useElysiaStore((state) => state.setChatAgent);

  const onHide = () => {
    if (type === 'soft') {
      hide();
    } else {
      hide();
      navigate('/');
      setChatAgent?.('Generic');
    }
  };

  return (
    <Modal
      show={show}
      keyboard={false}
      dialogClassName="elysia-modal"
      data-testid="update-profile-modal"
      className="block-modal"
      centered
    >
      <Modal.Header>
        <Modal.Title data-testid="update-profile-heading">Update Your Profile</Modal.Title>
      </Modal.Header>
      <Modal.Body className="d-flex">
        <div>
          <img src={icon_elysia_brain} alt="Elysia" data-testid="update-profile-elysia-logo" />
        </div>
        <p className="mb-3" data-testid="update-profile-modal-sub-heading">
          Without an updated profile, you're not getting the best out of Career Coach. Update it now
          then start exploring.
        </p>
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        <Button
          variant="secondary"
          data-testid="update-profile-modal-cancel-button"
          className="light-with-border"
          onClick={onHide}
        >
          {type === 'soft' ? 'Dismiss' : 'Exit'}
        </Button>
        <div>
          <Button
            variant="primary"
            data-testid="update-profile-modal-proceed-button"
            className="light-with-border me-2"
            onClick={() => navigate('/app-store')}
          >
            Explore AI Apps
          </Button>
          <Button
            variant="primary"
            data-testid="update-profile-modal-proceed-button"
            className="blue-without-border"
            onClick={() => navigate('/myprofile')}
          >
            Update Profile
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default BlockModal;
